<template>
    <side-panel @close="close">
        <template #header>
            <h3 class="mt-0 clearfix">
                {{ $l10n.__('Champs personnalisés') }}
            </h3>
        </template>
        <template #content class="prelative">
            <preloader :display="loading" />

            <section v-if="!loading">
                <!-- CF GROUP -->
                <!-- check if custom field has value -->
                <customfields
                    v-if="customFields.length > 0"
                    :cfs="customFields"
                    :cfv="customFieldValues"
                    :emitEditSuccess="emitEditSuccess"
                    :mode="mode"
                    :errors="errors"
                />
                <div v-else class="acenter">
                    <p>{{ $l10n.__('Aucun champ personnalisé défini') }}</p>
                    <CompassButton
                        :label="$t.__('forms.CustomfieldsForm.configure_custom_fields')"
                        type="secondary"
                        @click="goToCustomfields"
                    />
                </div>
            </section>
        </template>

        <template v-if="mode == 'edit' && !loading && customFields.length > 0" #footer>
            <CompassButton
                :label="$t.__('common.actions.cancel')"
                type="secondary"
                @click.prevent="close"
            />
            <CompassButton
                :label="$t.__('common.actions.save')"
                class="ml-3"
                @click.prevent="save"
            />
        </template>
    </side-panel>
</template>

<script>
import { goToUrl } from 'vueDir/helpers.js';
import FormMixins from '../../mixins/FormMixins';
import Customfields from './Customfields.vue';
import Preloader from 'vcomponents/utilities/Preloader.vue';
import SidePanel from 'vcomponents/utilities/SidePanel.vue';

export default {
    components: {
        Preloader,
        SidePanel,
        Customfields,
    },
    mixins: [FormMixins],
    props: {
        linkedid: {
            type: [Number, Boolean],
            required: false,
            default: 0,
        },
        linkedtype: {
            type: [String],
            required: false,
            default: '',
        },
        emitEditSuccess: {
            type: String,
            required: false,
            default: 'listing:refresh',
        },
        route: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            loading: true,
            mode: 'edit',
        };
    },
    created() {
        this.fetch();
    },
    methods: {
        fetch() {
            this.$ajax.get(this.route, {}, (response) => {
                this.customFields = response.customFields;
                this.customFieldValues = response.customFieldValues;
                this.permissions = response.permissions;
                this.dataLoaded = true;
                this.loading = false;
            });
        },
        close() {
            this.$emit('close', this.customFieldValues);
        },
        save() {
            this.loading = true;
            this.$ajax.put(
                this.route,
                {},
                { customFieldValues: this.customFieldValues },
                (response) => {
                    Push.success(
                        this.$l10n.__('Les champs personnalisés ont bien été mis à jour.'),
                    );
                    this.close();
                    EventBus.emit(this.emitEditSuccess, response);
                    this.loading = false;
                },
                (error) => {
                    this.errors.setErrors(error.response.data.error.message);
                    Push.error(
                        this.$l10n.__(
                            'Une erreur est survenue lors de la mise à jour des champs personnalisés',
                        ),
                    );
                    this.loading = false;
                },
            );
        },
        goToCustomfields() {
            return goToUrl('/?_f=customfields&amp;action=cffields');
        },
    },
};
</script>


